import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Panel from '../../../shared/Panel'
import Text from '../../../shared/Text'
import FormField from '../../../shared/FormField'
import Button from '../../../shared/Button'

import styles from './EnterPurchaseDate.module.scss'

const propTypes = {
  onPurchaseDate: PropTypes.func.isRequired
}

const Explain = props => <Text size='s' align='center' variant='neutralCool' variantCount='600' {...props} />

const EnterPurchaseDate = ({ onPurchaseDate }) => (
  <>
    <Panel.Heading>
      <FormattedMessage id='NewHome.EnterPurchaseDate.heading' defaultMessage='When did you purchase this home?' />
    </Panel.Heading>
    <Explain className={styles.one}>
      <FormattedMessage
        id='NewHome.EnterPurchaseDate.explain'
        defaultMessage='Homebot values the security of your home financial details'
      />
    </Explain>

    <form
      className={styles.form}
      onSubmit={e => {
        e.preventDefault()
        onPurchaseDate()
      }}
    >
      <FormField.Month required className={styles.month} />
      <FormField.Year required className={styles.year} />
      <Button primary type='submit' className={styles.submit}>
        <FormattedMessage id='NewHome.EnterPurchaseDate.submitButton' defaultMessage='Go' />
      </Button>
    </form>
  </>
)

EnterPurchaseDate.propTypes = propTypes

export default EnterPurchaseDate
